import React from 'react';
import Loadable from 'react-loadable';
import { Icon } from 'antd';

const LoadingComponent = () => <Icon type="loading" />;

export const loadSingle = options => Loadable({
  loading: LoadingComponent,
  ...options
});

export const loadMultiple = options => Loadable.Map({
  loading: LoadingComponent,
  ...options
});



// WEBPACK FOOTER //
// ./src/utils/loadable.js